import{caf as r,now as a,raf as e}from"@essentials/raf";var l=a=>{r(a.v||-1)},t=(r,l)=>{var t=a(),v={},o=()=>{a()-t<l?v.v=e(o):r.call(null)};return v.v=e(o),v};export default t;export{l as clearRequestTimeout,t as requestTimeout};
//# sourceMappingURL=index.mjs.map
